// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/organization.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateOrganizationRequest, GetOrganizationRequest, ListOrganizationsRequest, ListOrganizationsResponse, Organization, UpdateOrganizationRequest } from "./organization_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.OrganizationService
 */
export const OrganizationService = {
  typeName: "omnios.v1.OrganizationService",
  methods: {
    /**
     * @generated from rpc omnios.v1.OrganizationService.ListOrganizations
     */
    listOrganizations: {
      name: "ListOrganizations",
      I: ListOrganizationsRequest,
      O: ListOrganizationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrganizationService.GetOrganization
     */
    getOrganization: {
      name: "GetOrganization",
      I: GetOrganizationRequest,
      O: Organization,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrganizationService.CreateOrganization
     */
    createOrganization: {
      name: "CreateOrganization",
      I: CreateOrganizationRequest,
      O: Organization,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrganizationService.UpdateOrganization
     */
    updateOrganization: {
      name: "UpdateOrganization",
      I: UpdateOrganizationRequest,
      O: Organization,
      kind: MethodKind.Unary,
    },
  }
};

